import React from 'react';
import type { AgnesDataTableColumn } from '@agnes/ui';

/**
 * Sufixo de `data-qa` a partir de um enum (ex.: PENDENTE_DE_ESCLARECIMENTO ->
 * pendente-de-esclarecimento). Sempre kebab-case, independente do texto exibido.
 */
export const qaKey = (k: string): string => k.toLowerCase().replace(/_/g, '-');

/**
 * Envolve o conteúdo de cada célula de uma AgnesDataTable num
 * <span data-qa="<prefixo>-celula-<chave da coluna>-<id da linha>"> para a automação ler o valor
 * exibido (a chave é a mesma do `-col-<chave>` que o DS põe no cabeçalho). `contents` não gera
 * caixa: não altera o layout. A coluna `acoes` fica de fora (seus botões já têm data-qa próprio).
 */
export function comQaNasCelulas<T extends Record<string, unknown>>(
  prefixo: string,
  colunas: AgnesDataTableColumn<T>[],
  idDaLinha: (linha: T) => string,
): AgnesDataTableColumn<T>[] {
  return colunas.map((c) =>
    c.key === 'acoes'
      ? c
      : {
          ...c,
          render: (linha: T) => (
            <span className="contents" data-qa={`${prefixo}-celula-${c.key}-${idDaLinha(linha)}`}>
              {c.render ? c.render(linha) : (linha[c.key] as React.ReactNode)}
            </span>
          ),
        },
  );
}
